export default __webpack_public_path__ + "static/media/c-introduce-item-img-01.464f9097.png";